import { gql } from '@apollo/client';

export interface ProcedureStatusColor {
  status: string;
  color: string;
  flash?: boolean;
  /** Disable status colors/contour flashing on the schedule; keep the procedure visible. */
  excludeFromSchedule?: boolean;
  /** Disable status colors/contour flashing on the monitor; keep the patient visible. */
  excludeFromMonitor?: boolean;
}

export const procedureStatusColorsQuery = gql`
  query procedureStatusColors {
    procedureStatusColors {
      status
      color
      flash
      excludeFromSchedule
      excludeFromMonitor
    }
  }
`;

export const setProcedureStatusColorsMutation = gql`
  mutation setProcedureStatusColors($colors: [ProcedureStatusColorInput!]!) {
    setProcedureStatusColors(colors: $colors) {
      status
      color
      flash
      excludeFromSchedule
      excludeFromMonitor
    }
  }
`;

export default {
  list: procedureStatusColorsQuery,
  set: setProcedureStatusColorsMutation,
};
